/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Err_Number_InvalidInputs */

const vi_form_err_number_invalid = /** @type {(inputs: Form_Err_Number_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập số hợp lệ`)
};

/**

* @param {Form_Err_Number_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const form_err_number_invalid = /** @type {((inputs?: Form_Err_Number_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Err_Number_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_form_err_number_invalid(inputs)
});